export default "__VITE_ASSET__CKtz7BKc__"